const isCaseParentIdRejectedEnum = {
    notDeclined: 1,
    prepareDeclination: 2,
    Declined: 3,
    UserSentBack: 4,
}

export default isCaseParentIdRejectedEnum